export default "__VITE_ASSET__CXF_zwFV__"